import React, { useEffect, useState } from 'react'
import Breadcrumbs from '../../common/Breadcrumbs'
import Services from './Services'
import Pricing from '../../Reusable/Pricing'
import Line from "../../../assets/images/line.png"
import ContactSection from './ContactSection'
import { axiosInstance } from '../config'
import Loader from '../../common/Loader'
import { Helmet } from 'react-helmet'

const ServiceIndex = () => {

    const [data ,setdata] = useState([]);
    const [loading,setLoading] = useState([]);
    useEffect(() => {
        getData();
    },[])


    const getData = () => {
        setLoading(true)
        axiosInstance.get(`settings`)
            .then(res => {
                setdata(res?.data?.settings)
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false)
            })
    }
    return (
        <>
        <Helmet>
            <title>{data[3]?.metatitle || "Precision Contract Cleaning"}</title>
            <meta name="description" content={data[3]?.metadescription || "Precision Contract Cleaning"} />
            <meta name="keywords" content={data[3]?.metakeywords || "Precision Contract Cleaning"} />
        </Helmet>
            {loading && <Loader/>}
            <Breadcrumbs
                title={data[3]?.title	}
                description={data[3]?.subtitle}
                image={data[3]?.imageUrl}
            />
            <Services />
            {/* <Pricing Line={Line} /> */}
            <ContactSection />
        </>
    )
}

export default ServiceIndex